import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SalesIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_562_1754)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M0.5625 17.4375H17.4375",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.5 12.1875H2.25C2.10142 12.1894 1.95947 12.2493 1.8544 12.3544C1.74933 12.4595 1.68944 12.6014 1.6875 12.75V17.4375H5.0625V12.75C5.06056 12.6014 5.00067 12.4595 4.8956 12.3544C4.79053 12.2493 4.64858 12.1894 4.5 12.1875Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.125 9.1875H7.875C7.72642 9.18944 7.58447 9.24933 7.4794 9.3544C7.37433 9.45947 7.31444 9.60142 7.3125 9.75V17.4375H10.6875V9.75C10.6856 9.60142 10.6257 9.45947 10.5206 9.3544C10.4155 9.24933 10.2736 9.18944 10.125 9.1875Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.75 6.1875H13.5C13.3514 6.18944 13.2095 6.24933 13.1044 6.3544C12.9993 6.45947 12.9394 6.60142 12.9375 6.75V17.4375H16.3125V6.75C16.3106 6.60142 16.2507 6.45947 16.1456 6.3544C16.0405 6.24933 15.8986 6.18944 15.75 6.1875Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.13525 6.93008L15.1878 1.45508",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.2947 3.8475L15.1872 1.455L12.8022 0.5625",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_562_1754",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
